import React from 'react';
import { set } from 'dot-prop-immutable';
import { connect } from 'react-redux';
import { toolFormAttr, toolCollapseAttr, getLocale } from '@utils/util';
import { SimpleForm as Form, Collapse, Switch, Input } from '@whalecloud/fdx';
import CommonItemSettings from '@whalecloud/page-builder-base-components/components/ElementSettings/CommonItemSettings';
import ComponentRemoteOptionSettings from './ComponentRemoteOptionSettings';

const { Panel } = Collapse;

const valueKey = 'data.componentSettings';


const SelectSettings = (props: any) => {
  const messages = getLocale();
  const { updateElement, element } = props;
  const { data: { componentSettings = {} } = {} } = element;
  const sourceKey = 'data.componentSettings';
  const targetKey = 'transfer';

  const {
    showSearch = false,
    showSelectAll = true,
    titles = ["Source", "Target"],
    label = 'label',
    key = 'id'
  } = componentSettings;

  const initialValues = {
    showSearch,
    showSelectAll,
    autoInitialize: false,
    titles,
    label,
    key
  };

  const onFormChange = (obj: Object) => {
    Object.keys(obj).forEach((key: string) => {
      // if (['label', 'key'].includes(key)) return;
      const propName = `${valueKey}.${key}`;
      let value = obj[key];
      if(key === 'titles') {
        value = obj[key].split(",");
      }
      const newElement = set(element, propName, value);
      updateElement({
        element: newElement,
      });
    });
  };

  return (
    <Collapse {...toolCollapseAttr} defaultActiveKey={['1', '2', '3']}>
      <Panel header={messages.PAGEBUIDER_SETTINGS} key="1">
        {/* <CommonItemSettings
          formLabelHide
          placeholderHide
          defaultValueHide
          allowClearHide
          requiredHide
          showAutoInitialize={false}
        /> */}
        <Form
          {...toolFormAttr}
          initialValues={initialValues}
          onValuesChange={onFormChange}
        >
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_MPDAL_TITLE} name="titles">
            <Input />
          </Form.Item>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_TRANSFER_LABEL} name="label">
            <Input />
          </Form.Item>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_TRANSFER_KEY} name="key">
            <Input />
          </Form.Item>
          <Form.Item
            label={messages.PAGEBUIDER_ELEMENT_PROPERTY_AUTOINITIALIZE}
            name="autoInitialize"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
          <Form.Item
            label={messages.PAGEBUIDER_ELEMENT_PROPERTY_SEARCH}
            name="showSearch"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
          <Form.Item
            label={messages.PAGEBUIDER_ELEMENT_PROPERTY_SELECT_ALL}
            name="showSelectAll"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
        </Form>
      </Panel>
      <Panel header={messages.PAGEBUIDER_SETTINGS_FORM_TABS_OPTIONS} key="2">
        <ComponentRemoteOptionSettings sourceKey={sourceKey} targetKey={targetKey} />
      </Panel>
    </Collapse>
  );
};

const mapDispatchToProps = dispatch => ({
  updateElement: payload => {
    dispatch({
      type: 'appBuilder/updateAndFlattenElement',
      payload,
    });
  },
});

export default connect<any, any, any>(() => ({}), mapDispatchToProps)(SelectSettings);
